import { client } from "@lib/api"
import useSWR from "swr"

type Step = {
    title: string,
    description: string,
    icon_url: string,
    navigate_to: string,
    value: number,
    unit: string
}

type ReferralJourney = {
    referral_eligibility: boolean
    steps: Step[]
    steps_completed: number
    max_steps: number
    program_referee_reward_amount: number
    minimum_top_up: number
}

const useReferralJourney = () => {
    const { data, isLoading, error } = useSWR('/v2/wallet/referral/journey', client.doGet)

    return {
        data: data as ReferralJourney | undefined,
        isLoading,
        error
    }
}

export default useReferralJourney